var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('a',{attrs:{"href":_vm.excelFileUrl,"target":"_blank"}},[_c('a-button',{attrs:{"icon":"download","size":_vm.size}},[_vm._v("Download Excel")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }